import * as _ from "lodash";
import { ActionWithDispatch } from "common/actionWithDispatch";
import { ApiCallStarted, ApiCallSucceeded, ApiCallFailed, ApiCallCheckStatus } from "./saveIndicator.actions";
import { Dispatch } from "redux";
import Event, { EventAction } from "common/event";

const throttledDispatch = _.debounce(function (dispatch, ev) {
  dispatch(ev);
}, 1000);

export default function trackApiCall<EventType extends Event, ResolvedType = EventAction<EventType>>(action: ActionWithDispatch<EventType, ResolvedType>): ActionWithDispatch<EventType, ResolvedType> {
  return function (dispatch: any) {
    dispatch(new ApiCallStarted().toObject());
    const result = action(dispatch);
    result.then(() => {
      dispatch(new ApiCallSucceeded().toObject());
    })
      .catch(() => {
        dispatch(new ApiCallFailed().toObject());
      })
      .finally(() => {
        throttledDispatch(dispatch, new ApiCallCheckStatus().toObject())
      });
    return result;
  };
}

//TODO: once we refactor everything to use this pattern, remove the old one and rename this
export async function trackApiCallNew<T>(dispatch: Dispatch, action: (dispatch: Dispatch) => Promise<T>): Promise<T> {
  dispatch(new ApiCallStarted().toObject());
  try {
    const result = await action(dispatch);
    dispatch(new ApiCallSucceeded().toObject());
    return result;
  }
  catch (error) {
    dispatch(new ApiCallFailed().toObject());
    throw error;
  }
  finally {
    throttledDispatch(dispatch, new ApiCallCheckStatus().toObject())
  }
}